import script from "./history_chart.vue?vue&type=script&setup=true&lang=js"
export * from "./history_chart.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__